import React from 'react';
import {Link} from 'gatsby';

const Nav = () => {
  return (
    <nav className="menu">
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/blog">Blog</Link>
        </li>
        <li>
          <Link to="/docs/react">React Docs</Link>
        </li>
        <li>
          <Link to="/docs/ios">iOS Docs</Link>
        </li>
        <li>
          <Link to="/docs/android/a-nested-thing">Android Docs</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
